module.exports = __webpack_public_path__ + "static/media/arrow-right-solid.fa405868.svg";